var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-xl-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }